import { render, staticRenderFns } from "./supporter.vue?vue&type=template&id=5d194b51&scoped=true&"
import script from "./supporter.vue?vue&type=script&lang=js&"
export * from "./supporter.vue?vue&type=script&lang=js&"
import style0 from "./supporter.vue?vue&type=style&index=0&id=5d194b51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d194b51",
  null
  
)

export default component.exports